var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "b-navbar",
        {
          staticClass: "header",
          attrs: {
            id: "site-navbar",
            sticky: "",
            toggleable: "md",
            type: "dark",
            variant: "primary"
          }
        },
        [
          _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
          _vm._v(" "),
          _c("b-navbar-brand", { attrs: { href: "#" } }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: "/logo_white.svg" }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { "is-nav": "", id: "nav_collapse" } },
            [
              _c(
                "b-navbar-nav",
                [
                  _c(
                    "b-nav-item",
                    { attrs: { href: "#", to: { name: "systems" } } },
                    [_vm._v(_vm._s(_vm.$t("routes.systems")) + " ")]
                  ),
                  _vm._v(" "),
                  _vm.role === "EllipseAdmin"
                    ? _c(
                        "b-nav-item",
                        { attrs: { href: "#", to: { name: "users" } } },
                        [_vm._v(_vm._s(_vm.$t("routes.users")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.role === "EllipseAdmin"
                    ? _c(
                        "b-nav-item",
                        {
                          attrs: {
                            href: "#",
                            to: { name: "transactionreports" }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("routes.transactionreports")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.role === "EllipseAdmin"
                    ? _c(
                        "b-nav-item",
                        {
                          attrs: {
                            href: "#",
                            to: { name: "templatedefinitions" }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("routes.templatedefinitions")))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          _vm.showAbout = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("about")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "test",
                      attrs: { text: _vm.$t("language"), right: "" }
                    },
                    _vm._l(_vm.languages, function(lang, index) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: index,
                          attrs: {
                            href: "#",
                            active: _vm.language === lang.value,
                            "active-class": "language-active"
                          },
                          on: {
                            click: function($event) {
                              return _vm.setLang(lang.value)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(lang.title) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    { attrs: { right: "" } },
                    [
                      _c("template", { slot: "button-content" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("user.user")) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-item", { attrs: { disabled: "" } }, [
                        _vm._v(_vm._s(_vm.name))
                      ]),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.test()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("user.settings")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { href: "#" }, on: { click: _vm.logoutUser } },
                        [_vm._v(_vm._s(_vm.$t("user.signout")))]
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _c(
          "svg",
          {
            attrs: {
              version: "1.1",
              id: "Layer_1",
              xmlns: "&ns_svg;",
              "xmlns:xlink": "&ns_xlink;",
              width: "21.56",
              height: "14.02",
              viewBox: "0 0 64.705 42.064",
              overflow: "visible",
              "enable-background": "new 0 0 64.705 42.064",
              "xml:space": "preserve"
            }
          },
          [
            _c("g", [
              _c("path", {
                attrs: {
                  d:
                    "M0,42.064L24.258,0l24.258,42.064H40.43L24.24,14.08L8.086,42.064H0z M16.172,42.064l10.793-18.686l4.043,7.014l-2.707,4.658h5.396l4.043,7.014H16.172z M33.68,11.707l6.75-11.672l24.275,42.029H51.223l-4.061-7.014h5.414L40.412,14.063l-2.672,4.658L33.68,11.707z"
                }
              })
            ])
          ]
        ),
        _vm._v(
          "\n\n     Logos Design A/S | Nærum Hovedgade 6 | DK-2850 Nærum, Danmark | Tel +45 45 87 78 99\n  "
        )
      ]),
      _vm._v(" "),
      _c("user-modal", {
        attrs: {
          "modal-action": "edit",
          visible: _vm.showUserDialog,
          user: _vm.user
        },
        on: {
          "update:visible": function($event) {
            _vm.showUserDialog = $event
          },
          "update:user": function($event) {
            _vm.user = $event
          },
          success: _vm.pling
        }
      }),
      _vm._v(" "),
      _c("about", {
        model: {
          value: _vm.showAbout,
          callback: function($$v) {
            _vm.showAbout = $$v
          },
          expression: "showAbout"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ec6b00f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec6b00f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/Layout.vue
// module id = 764
// module chunks = 0